import { useTranslation } from 'react-i18next';

export default function Features() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-timer-line',
      title: t('why.time.title'),
      desc: t('why.time.desc'),
    },
    {
      icon: 'ri-stack-line',
      title: t('why.organize.title'),
      desc: t('why.organize.desc'),
    },
    {
      icon: 'ri-shield-star-line',
      title: t('why.safety.title'),
      desc: t('why.safety.desc'),
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            {t('why.title')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((f) => (
            <div
              key={f.title}
              className="group p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}